import axios from 'axios'
// import jwt_decode from 'jwt-decode'

import {
  GET_USER,
  GET_USERS_SIGNATURE,
  GET_TEAM_USER,
  GET_ALL_USERS,
  CREATE_USER,
  RESET_USER,
  SET_PROFILE_IMAGE,
  GET_PROFILE_IMAGE,
  GET_TEAMUSER_PROFILE_IMAGE,
  GET_PROFILE_IMAGE_CURRENT_USER,
  RESET_TEAMUSER,
  SET_USER_SIGNATURE,
  RESET_SIGNATURE,
  GET_USERS_FOR_DROPDOWN,
  GET_USERS_EXPECTATIONS,
  CHANGE_USERS_EXPECTATIONS,
  SET_USERS_FOR_CUSTOM_SELECT,
  GET_USER_RATING,
  GET_USERS_FOR_SELECT,
  GET_MY_TEAM,
  DECRYPT,
  GET_USER_OPTIONS,
  UPDATE_USER_OPTIONS,
} from './types'

import { GET_ERRORS } from '../../../actions/types'
import {
  // setCurrentUser,
  setRcSessionData,
} from '../../Login/redux/authActions'
// import setAuthToken from '../../../utils/setAuthToken'
import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'
export const getUser = (userId) => async (dispatch) => {
  try {
    const response = await axios.get(`/users/${userId}`)
    dispatch({
      type: GET_USER,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}
export const getTeamUser = (userId) => async (dispatch) => {
  try {
    let response
    if (userId) {
      response = await axios.get(`/users/team/${userId}`)
      dispatch({
        type: GET_TEAM_USER,
        payload: response.data,
      })
      if (response.status === 200) {
        return response.data
      }
    } else {
      dispatch({
        type: GET_TEAM_USER,
        payload: [],
      })
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const getAllUsers = (options) => async (dispatch) => {
  try {
    const response = await axios.get('/users', { params: { ...options } })
    dispatch({
      type: GET_ALL_USERS,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getMyTeam = () => async (dispatch) => {
  try {
    const response = await axios.get('/users/my-team')
    dispatch({
      type: GET_MY_TEAM,
      payload: response.data,
    })
  } catch (error) {
    dispatch({
      type: GET_MY_TEAM,
      payload: [],
    })
  }
}

export const getUsersForDropDown = () => async (dispatch) => {
  try {
    const response = await axios.get('/users/users-for-assign')
    dispatch({
      type: GET_USERS_FOR_DROPDOWN,
      payload: response.data,
    })
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

export const getUsersForCustomSelect = (divisionId, isAll) => async (dispatch) => {
  const response = await axios.get(`/users/users-for-custom-select/${isAll || divisionId}/all`)
  dispatch({
    type: SET_USERS_FOR_CUSTOM_SELECT,
    payload: response.data,
  })
  return response.data
}

export const getFundingSelectOptions = (contactId) => async (dispatch) => {
  try {
    const response = await axios.get(`/users/funding-options/${contactId}`)
    dispatch({
      type: SET_USERS_FOR_CUSTOM_SELECT,
      payload: response.data,
    })
  } catch (error) {
    dispatch({
      type: SET_USERS_FOR_CUSTOM_SELECT,
      payload: [],
    })
  }
}

export const getUsersByDivisionAndRole = (divisionId, roleId) => async (dispatch) => {
  try {
    const response = await axios.get(`/users/users-for-custom-select/${divisionId}/${roleId}`)
    dispatch({
      type: SET_USERS_FOR_CUSTOM_SELECT,
      payload: response.data,
    })
  } catch (error) {
    dispatch({
      type: SET_USERS_FOR_CUSTOM_SELECT,
      payload: [],
    })
  }
}

export const getUsersForCustomSelectByDivision = (divisionId, all) => async (dispatch) => {
  const response = await axios.get(`/users/users-for-selected-division/${divisionId}?all=${all}`)
  dispatch({
    type: SET_USERS_FOR_CUSTOM_SELECT,
    payload: response.data,
  })
}

export const updateUser = (userId, data) => async (dispatch) => {
  try {
    await axios.patch(`/users/${userId}`, data)

    //! This section is commented out because it would automatically log in the user after updating their data. The logic was modified in commit "ring central integration on frontend"

    // const { token } = response.data
    // sessionStorage.setItem('CRMToken', token)
    // setAuthToken(token)
    // const decoded = jwt_decode(token)
    // console.log(decoded)
    // dispatch(setCurrentUser(decoded))
    // dispatch(getImage(decoded.userId, decoded.imageId, true))
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const updateAuthData = (authData, userId) => async (dispatch) => {
  try {
    const lastUpdateTime = new Date().getTime()
    dispatch(
      setRcSessionData({
        accessToken: authData.access_token,
        refreshToken: authData.refresh_token,
        expiresIn: authData.expires_in,
        refreshTokenExpiresIn: authData.refresh_token_expires_in,
        expireTime: authData.expire_time,
        refreshTokenExpireTime: authData.refresh_token_expire_time,
        rcLastUpdateTime: lastUpdateTime,
      })
    )

    await axios.post('/users/set-rc-auth-data', {
      rcData: { ...authData, last_update_time: lastUpdateTime },
      userId,
    })
  } catch (err) {
    console.log(err)
  }
}

export const createUser = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/users`, data)
    dispatch({
      type: CREATE_USER,
      payload: response.data,
    })
    return response
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const updateSingleValueUser = (userId, data) => async () => {
  try {
    await axios.patch(`/users/update/${userId}`, data)
  } catch (error) {
    throw new Error(error)
  }
}

export const resetUser = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_USER,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const resetSignature = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_SIGNATURE,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const resetTeamUser = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_TEAMUSER,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const postImage = (data) => async (dispatch) => {
  const response = await axios.post(`/users/image`, data)
  try {
    dispatch({
      type: SET_PROFILE_IMAGE,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}
export const getImage = (id, timestamp, loginUser) => async (dispatch) => {
  const response = await axios.get(`/users/image/${id}`, {
    params: { timestamp: timestamp },
  })
  try {
    dispatch({
      type: loginUser ? GET_PROFILE_IMAGE_CURRENT_USER : GET_PROFILE_IMAGE,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}
export const getTeamUserImage = (id, timestamp) => async (dispatch) => {
  const response = await axios.get(`/users/image/${id}`, {
    params: { timestamp: timestamp },
  })
  try {
    dispatch({
      type: GET_TEAMUSER_PROFILE_IMAGE,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getUserSignature = (signatureId) => async (dispatch) => {
  try {
    const response = await axios.get(`/signatures/${signatureId}?field=userId`)
    dispatch({
      type: GET_USERS_SIGNATURE,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}
export const updateSignature = (signatureId, model) => async (dispatch) => {
  try {
    const response = await axios.patch(`/signatures/${signatureId}?field=userId`, {
      signature: model,
      userId: signatureId,
    })
    dispatch({
      type: GET_USERS_SIGNATURE,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}
export const createSignature = (model, id) => async (dispatch) => {
  try {
    const response = await axios.post(`/signatures`, {
      signature: model,
      userId: id,
    })
    dispatch({
      type: SET_USER_SIGNATURE,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const changeUsersExpectations = ({ target }) => async (dispatch) => {
  const { name, value } = target
  let data = {}
  if (!value && value !== 0) {
    if (name.includes('Day')) {
      data = {
        [name]: null,
        [name.replace('Day', 'Week')]: null,
        [name.replace('Day', 'Month')]: null,
        [name.replace('Day', 'Year')]: null,
      }
    }
    if (name.includes('Week')) {
      data = {
        [name]: null,
        [name.replace('Week', 'Day')]: null,
        [name.replace('Week', 'Month')]: null,
        [name.replace('Week', 'Year')]: null,
      }
    }
    if (name.includes('Month')) {
      data = {
        [name]: null,
        [name.replace('Month', 'Day')]: null,
        [name.replace('Month', 'Week')]: null,
        [name.replace('Month', 'Year')]: null,
      }
    }
    if (name.includes('Year')) {
      data = {
        [name]: null,
        [name.replace('Year', 'Day')]: null,
        [name.replace('Year', 'Week')]: null,
        [name.replace('Year', 'Month')]: null,
      }
    }
  }
  if (value) {
    {
      if (name.includes('Day')) {
        data = {
          [name]: +value,
          [name.replace('Day', 'Week')]: +value * 5,
          [name.replace('Day', 'Month')]: +value * 20,
          [name.replace('Day', 'Year')]: +value * 250,
        }
      }
      if (name.includes('Week')) {
        data = {
          [name]: +value,
          [name.replace('Week', 'Day')]: +value / 5,
          [name.replace('Week', 'Month')]: +value * 4,
          [name.replace('Week', 'Year')]: +value * 50,
        }
      }
      if (name.includes('Month')) {
        data = {
          [name]: +value,
          [name.replace('Month', 'Day')]: +value / 20,
          [name.replace('Month', 'Week')]: +value / 4,
          [name.replace('Month', 'Year')]: +value * 12.5,
        }
      }
      if (name.includes('Year')) {
        data = {
          [name]: +value,
          [name.replace('Year', 'Day')]: +value / 250,
          [name.replace('Year', 'Week')]: +value / 50,
          [name.replace('Year', 'Month')]: +value / 12.5,
        }
      }
    }
  }

  dispatch({
    type: CHANGE_USERS_EXPECTATIONS,
    payload: data,
  })
}

export const getUsersExpectations = (userId) => async (dispatch) => {
  const response = await axios.get(`/users/expectations/${userId}`)
  dispatch({
    type: GET_USERS_EXPECTATIONS,
    payload: response.data,
  })
}

export const setUsersExpectations = (data) => async (dispatch) => {
  const response = await axios.post(`/users/expectations/`, data)
  dispatch({
    type: GET_USERS_EXPECTATIONS,
    payload: response.data,
  })
}

export const removeUsersExpectations = () => async (dispatch) => {
  dispatch({
    type: GET_USERS_EXPECTATIONS,
    payload: {},
  })
}

export const getUsersExecutive = () => async (dispatch) => {
  const response = await axios.get('/users/users-executive')
  dispatch({
    type: GET_USERS_FOR_DROPDOWN,
    payload: response.data,
  })
}

export const getUserRating = (filter, userId) => async (dispatch) => {
  const response = await axios.get('/users/ratings', { params: { filter, userId } })
  dispatch({
    type: GET_USER_RATING,
    payload: response.data,
  })
}

export const getUsersForSelect = (divisionIds) => async (dispatch) => {
  const response = await axios.get('/users/for-select', { params: { divisionIds } })
  dispatch({
    type: GET_USERS_FOR_SELECT,
    payload: response.data,
  })
}

export const decrypt = (data) => async (dispatch) => {
  const response = await axios.post(`/auth/decrypt`, data)
  if (response.status === 200) {
    return response.data
  }
  dispatch({
    type: DECRYPT,
    payload: response.data,
  })
}

export const getUserOptions = (userId) => async (dispatch) => {
  const response = await axios.get(`/users/options/${userId}`)
  dispatch({
    type: GET_USER_OPTIONS,
    payload: response.data,
  })
}

export const updateUserOptions = (userId, data) => async (dispatch) => {
  try {
    const response = await axios.patch(`/users/options/${userId}`, data)
    dispatch({
      type: UPDATE_USER_OPTIONS,
      payload: response.data,
    })
    notificationSuccess('User Options Updated Successfully')
  } catch (error) {
    notificationDanger('Failed to update user options')
  }
}
